import { render, staticRenderFns } from "./ForgotPass.vue?vue&type=template&id=9e072a88&scoped=true&"
import script from "./ForgotPass.vue?vue&type=script&lang=js&"
export * from "./ForgotPass.vue?vue&type=script&lang=js&"
import style0 from "./ForgotPass.vue?vue&type=style&index=0&id=9e072a88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e072a88",
  null
  
)

export default component.exports